export default [
  {
    path: "/carRent/carList",
    component: () => import("../pages/carRent/carList"),
    meta: {
      title: "汽车租赁",
    },
  },
  {
    path: "/carRent/carDetail",
    component: () => import("../pages/carRent/carDetail"),
    meta: {
      title: "详情",
    },
  },
  {
    path: "/carRent/orderList",
    component: () => import("../pages/carRent/orderList"),
    meta: {
      title: "租赁申请",
    },
  },
  {
    path: "/carRent/orderDetail",
    component: () => import("../pages/carRent/orderDetail"),
    meta: {
      title: "租赁详情",
    },
  },
  {
    path: "/carRent/payedDetail",
    component: () => import("../pages/carRent/payedDetail"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/carRent/payDetail",
    component: () => import("../pages/carRent/payDetail"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/carRent/paySuccess",
    component: () => import("../pages/carRent/paySuccess"),
    meta: {
      title: "支付成功",
    },
  },
  {
    path: "/carRent/bannerDetail",
    component: () => import("../pages/carRent/bannerDetail"),
    meta: {
      title: "汽车租赁",
    },
  },
  {
    path: "/carRent/pdf",
    component: () => import("../pages/carRent/pdf"),
    meta: {
      title: "合同签署",
    },
  },
  {
    path: "/carRent/signature",
    component: () => import("../pages/carRent/signature"),
    meta: {
      title: "合同签署",
    },
  }
];
